export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  AUD: "A$",
  CAD: "C$",
  JPY: "¥",
  AED: "د.إ",
};

export const getCurrencySymbol = (currency = "USD") =>
  CURRENCY_SYMBOLS[currency] || currency;

export const formatPrice = (amount, currency = "USD") => {
  const symbol = getCurrencySymbol(currency);
  const num = Number(amount || 0);
  // JPY has no decimal places
  const decimals = currency === "JPY" ? 0 : 2;
  return `${symbol}${num.toFixed(decimals)}`;
};
